import {
  getCart,
  addToCart as addToCartApi,
  removeFromCart as removeFromCartApi,
  clearCart as clearCartApi,
} from "../api/cartApi";
import { CartItem } from "../types/common";

export interface OrderItemModel {
  id: string; //uuid
  price: number;
  package_name: string;
  packageId: string;
  msisdn: string;
  typeName: string;
  categoryName: string;
}

export const fetchCartRepo = async (
  customerId: string
): Promise<CartItem[]> => {
  const res = await getCart(customerId);
  const order = res.pending_order[0];

  return order.order_items.map((o: any) => ({
    packageId: o.package_id,
    price: Number(o.amount),
    packageName: o.counter_name,
    data: o.data ?? "",
    minutes: o.minutes ?? "",
    duration: o.duration ?? "",
    quantity: 1,
  }));
};

export interface OrderModel {
  orderId: string;
  amount: number;
}

export const getOrder = async (customerId: string): Promise<OrderModel> => {
  const data = await getCart(customerId);
  const order = data.pending_order[0];
  return { orderId: order.uuid, amount: order.total_amount };
};

export const addToCartRepo = async (
  customerId: string,
  items: CartItem[]
): Promise<string> => {
  const response = await addToCartApi(customerId, items);
  const orderId = response?.data?.[0]?.order_id;
  if (!orderId) {
    throw new Error(response?.message || "Failed to create order");
  }
  return orderId;
};

export const removeFromCartRepo = async (
  customerId: string,
  itemId: string
): Promise<void> => {
  try {
    await removeFromCartApi(customerId, itemId);
  } catch (error) {
    console.error("Error removing from cart:", error);
    throw new Error("Failed to remove item from cart.");
  }
};

export const clearCartRepo = async (customerId: string): Promise<void> => {
  try {
    console.log("clearing cart for customerId:", customerId);
    await clearCartApi(customerId);
  } catch (error) {
    console.error("Error clearing cart:", error);
    throw new Error("Failed to clear cart.");
  }
};
